import React, {useContext, useEffect, useState} from 'react';
import {observer} from 'mobx-react-lite';
import {Main, TemplateLogin} from '../../../patterns';
import {StoreContext} from '../base/root-store';
import {GenericError} from '../base/GenericError';

export const AdminLoginPage = observer((props: { redirectToDashboard: boolean }): JSX.Element => {
    const store = useContext(StoreContext).loginViewStore;

    const [email, setEmail] = useState<string>('');
    const [password, setPassword] = useState<string>('');

    useEffect(() => {
        store.onEnter();
    }, []);

    if (store.state === 'error') {
        return <Main><GenericError/></Main>;
    }

    const onLogin = (): Promise<void> => store.adminLogin(email, password, props.redirectToDashboard);

    return (
        <Main isLoading={store.state === 'loading'}>
            <TemplateLogin
                title="Log in"
                fields={[
                    {
                        label: 'Employee E-mail',
                        iconLeft: 'mail-closed',
                        id: 'text1',
                        name: 'field',
                        type: 'email',
                        value: email,
                        invalid: store.invalid,
                        onChange: (value): void => setEmail(value),
                    },
                    {
                        label: 'Admin Password',
                        iconLeft: 'key',
                        id: 'text2',
                        name: 'field',
                        type: 'password',
                        value: password,
                        invalid: store.invalid,
                        onChange: (value): void => setPassword(value),
                    },
                ]}
                button={{
                    text: 'Log in',
                    onClick: onLogin,
                }}
                onSubmit={onLogin}
            />
        </Main>
    );
});
